<!-- eslint-disable vue/valid-v-else -->
<template>
  <div>
    <b-sidebar
      id="sidebar-task-handler"
      sidebar-class="sidebar-lg"
      :visible="isTaskHandlerSidebarActive"
      bg-variant="white"
      shadow
      backdrop
      no-header
      right
      @change="(val) => $emit('update:is-task-handler-sidebar-active', val)"
      @hidden="clearForm"
    >
      <template #default="{ hide }">
        <!-- Header -->
        <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
          <div v-if="taskLocal.id">
            <b-button
              v-if="taskLocal.status == 'Kész'"
              size="sm"
              variant="outline-success"
              @click="updateStatus('Folyamatban')"
            >
              Kész
            </b-button>
            <span v-else>
              <b-button
                v-if="taskLocal.work_id != 'Saját feladat'"
                size="sm"
                variant="outline-secondary"
                @click="updateStatusToFinished(taskLocal.id)"
              >
                Késznek jelölés
              </b-button>
              <b-button
                v-else
                size="sm"
                variant="outline-secondary"
                @click="updateStatus('Kész')"
              >
                Késznek jelölés
              </b-button>
            </span>
            <b-button
              v-if="taskLocal.status == 'Folyamatban' && !taskLocal.in_progress && taskLocal.target_id == getUserID()"
              size="sm"
              variant="primary"
              class="ml-1"
              @click="in_progress(taskLocal.id);"
            >
              Folyamatban
            </b-button>
          </div>
          <h5
            v-else
            class="mb-0"
          >
            Feladat létrehozás
          </h5>
          <div>
            <feather-icon
              v-show="taskLocal.id"
              v-if="taskLocal.deleted == 0"
              icon="TrashIcon"
              class="cursor-pointer"
              @click="$emit('remove-task');taskLocal.deleted=1"
            />
            <feather-icon
              v-show="taskLocal.id"
              v-else
              icon="RefreshCcwIcon"
              class="cursor-pointer"
              @click="$emit('restore-task');;taskLocal.deleted=0"
            />
            <feather-icon
              class="ml-1 cursor-pointer"
              icon="XIcon"
              size="16"
              @click="hide"
            />
          </div>
        </div>

        <!-- Body -->
        <validation-observer
          #default="{ handleSubmit }"
          ref="refFormObserver"
        >

          <!-- Form -->
          <b-form
            class="p-2"
            @submit.prevent="handleSubmit(onSubmit)"
            @reset.prevent="resetForm"
          >

            <!-- Title -->
            <b-form-group
              label="Megnevezés"
              label-for="task-title"
            >
              <b-form-input
                id="task-title"
                v-model="taskLocal.title"
                autofocus
                trim
                placeholder="Feladat megnevezése"
              />
            </b-form-group>

            <b-form-group
              v-if="taskLocal.work_id != 'Nem projekttel kapcsolatos' && taskLocal.work_id != 'Saját feladat'"
              label="Munka azonosító"
              label-for="work_number"
            >
              <b-form-input
                id="work_number"
                v-model="taskLocal.work_number"
                autofocus
                trim
                placeholder="Munka azonosító"
              />
            </b-form-group>

            <b-form-group
              v-if="taskLocal.work_id != 'Nem projekttel kapcsolatos' && taskLocal.work_id != 'Saját feladat'"
              label="Megrendelő"
              label-for="customer"
            >
              <b-form-input
                id="customer"
                v-model="taskLocal.customer"
                autofocus
                trim
                placeholder="Megrendelő"
              />
            </b-form-group>
            <!-- Assignee -->
            <b-form-group
              v-if="taskLocal.work_id != 'Saját feladat'"
              label="Felelős"
              label-for="assignee"
            >
              <v-select
                v-model="taskLocal.assignee"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="preparatoryOptions"
                label="name"
                value="id"
                class="assignee-selector"
                input-id="assignee"
              />
              <small>Feladatot kiadta: <span
                class="badge badge-primary"
                style="cursor:pointer"
                @click="changeAssigneeToCreator(taskLocal.creator_id, taskLocal.creator_name)"
              >{{ taskLocal.creator_name }}</span></small>
            </b-form-group>

            <!-- due Date -->
            <validation-provider
              #default="validationContext"
              name="Due Date"
            >

              <b-form-group
                label="Határidő"
                label-for="due-date"
              >
                <b-form-input
                  v-model="taskLocal.end_date"
                  type="date"
                  class="form-control"
                  max="9999-12-31"
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>

            <b-form-group
              label="Prioritás"
              label-for="priority"
            >
              <v-select
                v-model="taskLocal.priority"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :close-on-select="true"
                :options="tagOptions"
                :reduce="option => option.value"
                input-id="priority"
              />
            </b-form-group>

            <!-- Description -->
            <b-form-group
              v-if="checkOwner(taskLocal.creator_id)"
              label="Leírás"
              label-for="task-description"
            >
              <quill-editor
                id="quil-content"
                v-model="taskLocal.description"
                :options="editorOption"
                class="border-bottom-0"
              />
              <div
                id="quill-toolbar"
                class="d-flex justify-content-end border-top-0"
              >
                <!-- Add a bold button -->
                <button class="ql-bold" />
                <button class="ql-italic" />
                <button class="ql-underline" />
                <button class="ql-align" />
                <button class="ql-link" />
              </div>
            </b-form-group>
            <div v-else-if="taskLocal.description !== null">
              <p><strong>Leírás</strong></p>
              <p v-html="taskLocal.description" />
            </div>
            <!-- Form Actions -->
            <div class="d-flex mt-2">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-2"
                type="submit"
              >
                {{ taskLocal.id ? 'Frissítés' : 'Hozzáadás ' }}
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="reset"
                variant="outline-secondary"
              >
                Visszaállítás
              </b-button>
            </div>
          </b-form>
        </validation-observer>
        <!-- /Form -->
        <div v-if="taskLocal.id != null">
          <b-modal
            id="createEmail"
            title="E-mail rögzítés"
            hide-footer
          >
            <b-row class="my-2 pl-1 pr-1">
              <b-col lg="12">
                <b-form-group
                  label="Megnevezés"
                  label-for="email_title"
                >
                  <b-form-input
                    id="email_title"
                    v-model="email_title"
                    class="w-100"
                    placeholder="Bármi megnevezés amiről belehet azonosítani"
                  />
                </b-form-group>
              </b-col>
              <b-col lg="12">
                <b-form-group
                  label="Link"
                  label-for="email_link"
                >
                  <b-form-input
                    id="email_link"
                    v-model="email_link"
                    class="w-100"
                    placeholder="E-mail linkje"
                  />
                </b-form-group>
              </b-col>
              <b-col lg="12">
                <b-form-group
                  label="Bejövő vagy kimenő"
                  label-for="email_incomming"
                >
                  <b-form-select
                    id="email_incomming"
                    v-model="email_incomming"
                    :options="incommingOptions"
                    class="w-100"
                    placeholder="E-mail linkje"
                  />
                </b-form-group>
              </b-col>
              <b-col
                lg="12"
                class="justify-content-end d-flex my-2"
              >
                <b-button
                  size="sm"
                  variant="danger"
                  @click="$bvModal.hide('createEmail')"
                >
                  Mégsem
                </b-button>
                <b-button
                  class="ml-1"
                  size="sm"
                  variant="success"
                  @click="saveEmail()"
                >
                  Rögzítés
                </b-button>
              </b-col>
            </b-row>
          </b-modal>
          <div class="col-lg-12">
            <h5 class="d-inline">
              Emailek
            </h5>
            <span
              v-b-modal.createEmail
              class="float-right badge badge-primary"
            >Új email</span>
            <div
              v-if="emails.length > 0"
              class="mail-box mt-1"
            >
              <div
                v-for="email in emails"
                :key="email.id"
                class="w-100"
              >
                <div class="row col-lg-12 align-items-center">
                  <p class="col-lg-2 mb-0">
                    <feather-icon
                      icon="MailIcon"
                      size="30"
                      class="text-primary"
                    />
                  </p>
                  <p
                    style="line-height: 1.0;"
                    class="col-lg-9 mb-0 pb-0"
                  >
                    <a
                      target="_blank"
                      :href="email.link"
                    >{{ email.title }}</a>
                    <br>
                    <small v-if="email.incomming==1">Bejövő</small>
                    <small v-else>Kimenő</small>
                  </p>
                  <p class="col-lg-1 mb-0">
                    <feather-icon
                      style="cursor: pointer;"
                      icon="XIcon"
                      size="20"
                      class="text-danger"
                      @click="deleteEmail(email.id)"
                    />
                  </p>
                </div>
                <hr>
              </div>
            </div>
            <div v-else>
              <p class="text-center">
                Nincsenek emailek rögzítve
              </p>
              <hr>
            </div>
          </div>
        </div>
        <div v-if="taskLocal.id != null">
          <b-modal
            id="createComment"
            title="Új megjegyzés hozzáfűzése"
            hide-footer
          >
            <b-row class="my-2 pl-1 pr-1">
              <b-col lg="12">
                <b-form-group
                  label="Megjegyzés"
                  label-for="comment_text"
                >
                  <b-form-textarea
                    id="comment_text"
                    v-model="comment_text"
                    class="w-100"
                    placeholder="Bármi feladahoz kapcsolódó megjegyzés"
                  />
                </b-form-group>
              </b-col>
              <b-col
                lg="12"
                class="justify-content-end d-flex my-2"
              >
                <b-button
                  size="sm"
                  variant="danger"
                  @click="$bvModal.hide('createComment')"
                >
                  Mégsem
                </b-button>
                <b-button
                  class="ml-1"
                  size="sm"
                  variant="success"
                  @click="saveComment()"
                >
                  Rögzítés
                </b-button>
              </b-col>
            </b-row>
          </b-modal>
          <div class="col-lg-12 mt-2 pb-0">
            <h5 class="d-inline">
              Megjegyzések
            </h5>
            <span
              v-b-modal.createComment
              class="float-right badge badge-primary"
              style="cursor:pointer"
            >Új megjegyzés</span>
            <div
              v-if="comments.length > 0"
              class="mail-box mt-1"
            >
              <div
                v-for="(comment, index) in comments"
                :key="index"
                class="w-100"
              >
                <div class="row col-lg-12">
                  <p class="col-lg-2 mb-0">
                    <b-avatar
                      size="32"
                      :variant="`light-primary`"
                      :text="avatarText(comment.name)"
                    />
                  </p>
                  <p
                    style="line-height: 1.0;"
                    class="col-lg-10 mb-0 pb-0 text-primary"
                  >
                    {{ comment.name }} <br><small>{{ comment.created_at }}</small>
                  </p>
                  <p
                    class="col-lg-12"
                    style="padding-top:4px"
                  >
                    <small>{{ comment.comment }}</small>
                  </p>
                </div>
              </div>
            </div>
            <div
              v-else
              class="mt-1"
            >
              <p class="text-center">
                Nincsenek megjegyzések
              </p>
            </div>
          </div>
        </div>
        <div v-if="taskLocal.id != null">
          <b-modal
            id="updateFile"
            title="Új fájl feltöltése"
            hide-footer
          >
            <b-row class="my-2 pl-1 pr-1">
              <b-col lg="12">
                <b-form-group
                  label="Fájl neve amiről beazonosítható"
                  label-for="file_name"
                >
                  <b-form-input
                    id="file_name"
                    v-model="file_name"
                    class="w-100"
                    placeholder="Fontos szerződés"
                    @change="onFileChange"
                  />
                </b-form-group>
              </b-col>
              <b-col lg="12">
                <b-form-group
                  label="Fájl (Támogatott formátumok: pdf, doc, docx, xls, xlsx, ppt, pptx, txt, jpg, jpeg, png, gif, zip, rar)"
                  label-for="file"
                >
                  <b-form-file
                    id="file"
                    v-model="file"
                    accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.jpg,.jpeg,.png,.gif,.zip,.rar"
                    multiple
                    class="w-100"
                  />
                </b-form-group>
              </b-col>
              <b-col
                lg="12"
                class="justify-content-end d-flex my-2"
              >
                <b-button
                  size="sm"
                  variant="danger"
                  @click="$bvModal.hide('updateFile')"
                >
                  Mégsem
                </b-button>
                <b-button
                  class="ml-1"
                  size="sm"
                  variant="success"
                  @click="saveFile()"
                >
                  Feltöltés
                </b-button>
              </b-col>
            </b-row>
          </b-modal>
          <div class="col-lg-12 mt-2 pb-5">
            <h5 class="d-inline">
              Csatolt fájlok
            </h5>
            <span
              v-b-modal.updateFile
              class="float-right badge badge-primary"
              style="cursor:pointer"
            >Fájl feltöltés</span>
            <div
              v-if="files.length > 0"
              class="mail-box mt-1"
              style="max-width:100%"
            >
              <div
                v-for="(file, index) in files"
                :key="index"
                class="d-flex align-items-center mb-2"
              >
                <!-- View icon - mindig megjelenik -->
                <feather-icon
                  style="cursor: pointer;"
                  icon="EyeIcon"
                  size="16"
                  :class="canPreviewFile(file) ? 'text-primary mr-2' : 'text-muted mr-2'"
                  :title="canPreviewFile(file) ? 'Megtekintés' : 'Ez a fájltípus nem tekinthető meg'"
                  @click="handleFileView(file.id, file)"
                />

                <!-- Download icon -->
                <feather-icon
                  style="cursor: pointer;"
                  icon="DownloadIcon"
                  size="16"
                  class="text-primary mr-2"
                  title="Letöltés"
                  @click="downloadPdf(file.id, file.name)"
                />

                <!-- File icon and name -->
                <span class="text-dark">
                  <feather-icon
                    v-if="isImageFile(file)"
                    icon="ImageIcon"
                    size="12"
                    class="text-success mr-1"
                  />
                  <feather-icon
                    v-else-if="isPdfFile(file)"
                    icon="FileTextIcon"
                    size="12"
                    class="text-danger mr-1"
                  />
                  <feather-icon
                    v-else
                    icon="FileIcon"
                    size="12"
                    class="text-primary mr-1"
                  />
                  {{ file.name }} ({{ file.created_at }})
                </span>
              </div>
            </div>
            <div
              v-else
              class="mt-1"
            >
              <p class="text-center">
                Nincsenek csatolt fájlok
              </p>
            </div>
          </div>
        </div>
      </template>
    </b-sidebar>

    <!-- Modern Image Viewer -->
    <b-modal
      :visible="showImageViewer"
      size="xl"
      hide-header
      hide-footer
      body-class="p-0"
      modal-class="modern-image-modal"
      @hidden="closeImageViewer"
    >
      <div class="modern-image-viewer">
        <!-- Header with controls -->
        <div class="image-header">
          <div class="image-title">
            <feather-icon
              icon="ImageIcon"
              size="20"
              class="text-white mr-2"
            />
            <span class="text-white">{{ currentImageName }}</span>
          </div>
          <div class="image-controls">
            <b-button
              variant="link"
              size="sm"
              class="text-white p-2"
              @click="imageZoomOut"
            >
              <feather-icon
                icon="ZoomOutIcon"
                size="18"
              />
            </b-button>
            <span class="zoom-indicator">{{ Math.round(imageZoom * 100) }}%</span>
            <b-button
              variant="link"
              size="sm"
              class="text-white p-2"
              @click="imageZoomIn"
            >
              <feather-icon
                icon="ZoomInIcon"
                size="18"
              />
            </b-button>
            <b-button
              variant="link"
              size="sm"
              class="text-white p-2 ml-2"
              @click="closeImageViewer"
            >
              <feather-icon
                icon="XIcon"
                size="20"
              />
            </b-button>
          </div>
        </div>

        <!-- Image content -->
        <div
          class="image-content-modern"
          @click="closeImageViewer"
        >
          <div class="image-wrapper">
            <img
              v-if="currentImageSrc"
              :src="currentImageSrc"
              :alt="currentImageName"
              class="modern-image"
              :style="{ transform: `scale(${imageZoom})` }"
              @click.stop
            >
          </div>
        </div>

        <!-- Bottom info bar -->
        <div class="image-footer">
          <small class="text-white-50">
            Kattintson a háttérre a bezáráshoz, vagy használja az ESC billentyűt
          </small>
        </div>
      </div>
    </b-modal>

    <!-- Modern PDF Viewer Modal -->
    <b-modal
      :visible="showPdfViewer"
      size="xl"
      hide-header
      hide-footer
      body-class="p-0"
      modal-class="modern-pdf-modal"
      @hidden="closePdfViewer"
    >
      <div class="modern-pdf-viewer">
        <!-- Header with controls -->
        <div class="pdf-header">
          <div class="pdf-title">
            <feather-icon
              icon="FileTextIcon"
              size="20"
              class="text-white mr-2"
            />
            <span class="text-white">{{ currentPdfName }}</span>
          </div>
          <div class="pdf-controls">
            <!-- Navigation controls -->
            <div class="nav-controls">
              <b-button
                variant="link"
                size="sm"
                class="text-white p-2"
                :disabled="currentPage <= 1"
                @click="previousPage"
              >
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="16"
                />
              </b-button>
              <span class="page-indicator">{{ currentPage }} / {{ totalPages }}</span>
              <b-button
                variant="link"
                size="sm"
                class="text-white p-2"
                :disabled="currentPage >= totalPages"
                @click="nextPage"
              >
                <feather-icon
                  icon="ChevronRightIcon"
                  size="16"
                />
              </b-button>
            </div>

            <!-- Zoom controls -->
            <div class="zoom-controls">
              <b-button
                variant="link"
                size="sm"
                class="text-white p-2"
                @click="zoomOut"
              >
                <feather-icon
                  icon="ZoomOutIcon"
                  size="16"
                />
              </b-button>
              <span class="zoom-indicator">{{ Math.round(pdfScale * 100) }}%</span>
              <b-button
                variant="link"
                size="sm"
                class="text-white p-2"
                @click="zoomIn"
              >
                <feather-icon
                  icon="ZoomInIcon"
                  size="16"
                />
              </b-button>
            </div>

            <!-- Close button -->
            <b-button
              variant="link"
              size="sm"
              class="text-white p-2 ml-2"
              @click="closePdfViewer"
            >
              <feather-icon
                icon="XIcon"
                size="20"
              />
            </b-button>
          </div>
        </div>

        <!-- PDF Content -->
        <div class="pdf-content-modern">
          <div class="pdf-wrapper-modern">
            <pdf
              v-if="currentPdfSrc"
              ref="pdfComponent"
              :src="currentPdfSrc"
              :page="currentPage"
              :quality="3"
              :text="true"
              :annotations="true"
              :resize="true"
              :style="{
                transform: `scale(${pdfScale})`,
                transformOrigin: 'top center',
                width: '700px',
                minHeight: '800px'
              }"
              @num-pages="onNumPagesLoaded"
              @page-loaded="onPageLoaded"
              @loading-failed="onPdfError"
            />
          </div>
        </div>

        <!-- Bottom info bar -->
        <div class="pdf-footer">
          <small class="text-white-50">
            Használja a zoom gombokat vagy a +/- billentyűket a nagyításhoz
          </small>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BAvatar, BButton, BFormInvalidFeedback, BFormSelect, BRow, BCol, BFormTextarea, BFormFile, BModal,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email, url } from '@validations'
import { avatarText } from '@core/utils/filter'
import formValidation from '@core/comp-functions/forms/form-validation'
import { toRefs } from '@vue/composition-api'
import { quillEditor } from 'vue-quill-editor'
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import pdf from 'vue-pdf'
import useTaskHandler from './useTaskHandler'

export default {
  components: {
    // BSV
    BFormSelect,
    BButton,
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BAvatar,
    BFormInvalidFeedback,
    BRow,
    BCol,
    BFormTextarea,
    BFormFile,
    BModal,

    // 3rd party packages
    vSelect,
    flatPickr,
    quillEditor,
    pdf,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isTaskHandlerSidebarActive',
    event: 'update:is-task-handler-sidebar-active',
  },
  props: ['isTaskHandlerSidebarActive', 'task', 'clearTaskData'],
  data() {
    return {
      comment_text: '',
      file_name: '',
      file: null,
      files: [],
      comments: [],
      emails: [],
      email_title: null,
      email_incomming: null,
      email_link: null,
      projectOptions: [],
      required,
      email,
      url,
      preparatoryOptions: [],
      incommingOptions: [
        {
          text: 'Bejövő',
          value: true,
        }, {
          text: 'Kimenő',
          value: false,
        },
      ],
      // Image viewer
      showImageViewer: false,
      currentImageSrc: '',
      currentImageName: '',
      imageZoom: 1,
      // PDF viewer
      showPdfViewer: false,
      currentPdfSrc: '',
      currentPdfName: '',
      currentPage: 1,
      totalPages: 1,
      pdfScale: 1.2,
    }
  },
  watch: {
    isTaskHandlerSidebarActive(val) {
      if (val) {
        this.getEmails()
        this.getComments()
        this.getFiles()
      }
    },
    showImageViewer(val) {
      if (val) {
        document.addEventListener('keydown', this.handleImageViewerKeydown)
      } else {
        document.removeEventListener('keydown', this.handleImageViewerKeydown)
      }
    },
    showPdfViewer(val) {
      if (val) {
        document.addEventListener('keydown', this.handlePdfViewerKeydown)
      } else {
        document.removeEventListener('keydown', this.handlePdfViewerKeydown)
      }
    },
  },
  mounted() {
    (async () => {
      this.assigneeOptions().then(res => {
        this.preparatoryOptions = res
      })
    })()

    axios({
      method: 'get',

      url: 'project/list/all',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    }).then(res => {
      this.projectOptions.push({
        value: 0,
        text: 'Nem tartozik projekthez',
      })
      res.data.forEach(project => {
        this.projectOptions.push({
          value: project.id,
          text: project.name,
        })
      })
    })
  },
  beforeDestroy() {
    // Clean up event listeners
    document.removeEventListener('keydown', this.handleImageViewerKeydown)
    document.removeEventListener('keydown', this.handlePdfViewerKeydown)
  },
  methods: {
    getUserID() {
      return JSON.parse(localStorage.getItem('user')).id
    },
    // File type detection methods
    getFileExtensionFromFile(file) {
      // Több helyről próbálja meg kinyerni a kiterjesztést
      let extension = ''

      // 1. Próbáljuk a path-ból (ha van)
      if (file.path && file.path.includes('.')) {
        extension = file.path.split('.').pop().toLowerCase()
      } else if (file.original_name && file.original_name.includes('.')) {
        // 2. Próbáljuk az original_name-ből (ha van)
        extension = file.original_name.split('.').pop().toLowerCase()
      } else if (file.file_name && file.file_name.includes('.')) {
        // 3. Próbáljuk a file_name-ből (ha van)
        extension = file.file_name.split('.').pop().toLowerCase()
      } else if (file.name && file.name.includes('.')) {
        // 4. Próbáljuk a name-ből (ha van pont)
        extension = file.name.split('.').pop().toLowerCase()
      } else if (file.mime_type) {
        // 5. Próbáljuk a mime_type-ból kitalálni
        extension = this.getExtensionFromMimeType(file.mime_type)
      }

      console.log('File object:', file)
      console.log(`Extracted extension: ${extension}`)
      return extension
    },
    isImageFile(file) {
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg']
      const extension = typeof file === 'string'
        ? file.split('.').pop().toLowerCase()
        : this.getFileExtensionFromFile(file)
      const isImage = imageExtensions.includes(extension)
      console.log(`Checking if file is image: ${isImage} (extension: ${extension})`)
      return isImage
    },
    isPdfFile(file) {
      const extension = typeof file === 'string'
        ? file.split('.').pop().toLowerCase()
        : this.getFileExtensionFromFile(file)
      const isPdf = extension === 'pdf'
      console.log(`Checking if file is PDF: ${isPdf} (extension: ${extension})`)
      return isPdf
    },
    getFileExtension(fileName) {
      return fileName.split('.').pop().toLowerCase()
    },
    canPreviewFile(file) {
      return this.isImageFile(file) || this.isPdfFile(file)
    },
    handleFileView(fileId, file) {
      if (this.isImageFile(file)) {
        this.viewImage(fileId, file.name || file.original_name || 'file')
      } else if (this.isPdfFile(file)) {
        this.viewPdf(fileId, file.name || file.original_name || 'file')
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Ez a fájltípus nem tekinthető meg előzetesen',
            icon: 'InfoIcon',
            variant: 'warning',
          },
        })
      }
    },
    updateStatusToFinished(id) {
      this.$emit('updateStatusToFinished', id)
    },
    in_progress(id) {
      axios({
        method: 'post',
        url: `project/task/in_progress/${id}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        data: {
          comment: this.comment_text,
          task_id: this.task.id,
          project_id: 0,
        },
      }).then(() => {
        // eslint-disable-next-line no-use-before-define
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sikeresen jelezve',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
      })
    },
    changeAssigneeToCreator(id, name) {
      this.taskLocal.assignee.id = id
      this.taskLocal.assignee.name = name
    },
    checkOwner(id) {
      if (id !== undefined && JSON.parse(localStorage.getItem('user')).id === id) {
        return true
      }
      return false
    },
    getMimeType(filename) {
      const extension = filename.split('.').pop().toLowerCase()
      const mimeTypes = {
        pdf: 'application/pdf',
        doc: 'application/msword',
        docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        xls: 'application/vnd.ms-excel',
        xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        ppt: 'application/vnd.ms-powerpoint',
        pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        txt: 'text/plain',
        jpg: 'image/jpeg',
        jpeg: 'image/jpeg',
        png: 'image/png',
        gif: 'image/gif',
        zip: 'application/zip',
        rar: 'application/x-rar-compressed',
      }
      return mimeTypes[extension] || 'application/octet-stream'
    },
    getExtensionFromMimeType(mimeType) {
      const extensionMap = {
        'application/pdf': 'pdf',
        'application/msword': 'doc',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
        'application/vnd.ms-excel': 'xls',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
        'application/vnd.ms-powerpoint': 'ppt',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
        'text/plain': 'txt',
        'image/jpeg': 'jpg',
        'image/png': 'png',
        'image/gif': 'gif',
        'application/zip': 'zip',
        'application/x-rar-compressed': 'rar',
      }
      return extensionMap[mimeType] || null
    },
    downloadPdf(id, originalFilename = 'file') {
      axios({
        method: 'post',

        url: 'project/file/download',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        responseType: 'blob',
        data: {
          id,
        },
      }).then(res => {
        // Try to get filename from Content-Disposition header
        let filename = originalFilename
        const contentDisposition = res.headers['content-disposition']
        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
          if (filenameMatch) {
            [, filename] = filenameMatch
            // Remove quotes if present
            filename = filename.replace(/['"]/g, '')
          }
        }

        // If we still don't have an extension, try to get it from Content-Type
        if (!filename.includes('.')) {
          const contentType = res.headers['content-type']
          const extension = this.getExtensionFromMimeType(contentType)
          if (extension) {
            filename = `${filename}.${extension}`
          }
        }

        const mimeType = res.headers['content-type'] || this.getMimeType(filename)
        const blob = new Blob([res.data], {
          type: mimeType,
        })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = filename
        link.click()

        // eslint-disable-next-line no-use-before-define
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sikeresen letöltve',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        this.getComments()
      }).catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: Object.values(error.response.data.errors)[0][0],
            icon: 'XOctagonIcon',
            variant: 'danger',
          },
        })
      })
    },
    onFileChange(e) {
      // eslint-disable-next-line prefer-destructuring
      this.file = e.target.files[0]
    },
    saveFile() {
      const formData = new FormData()
      if (this.file != null) {
        this.file.forEach(file => {
          formData.append('file[]', file)
        })
      }
      formData.append('task_id', this.task.id)
      formData.append('project_id', this.task.project_id)
      formData.append('file_name', this.file_name)

      axios({
        method: 'post',
        url: 'project/file/create',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'multipart/form-data',
        },
        data: formData,
      }).then(() => {
        // eslint-disable-next-line no-use-before-define
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sikeresen feltöltve',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        this.file_name = null
        this.$bvModal.hide('updateFile')
        this.getFiles()
      }).catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: Object.values(error.response.data.errors)[0][0],
            icon: 'XOctagonIcon',
            variant: 'danger',
          },
        })
      })
    },
    saveComment() {
      axios({
        method: 'post',

        url: 'project/comment/create',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        data: {
          comment: this.comment_text,
          task_id: this.task.id,
          project_id: 0,
        },
      }).then(() => {
        // eslint-disable-next-line no-use-before-define
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sikeresen létrehozva',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        this.comment_text = null
        this.$bvModal.hide('createComment')
        this.getComments()
      }).catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: Object.values(error.response.data.errors)[0][0],
            icon: 'XOctagonIcon',
            variant: 'danger',
          },
        })
      })
    },
    getComments() {
      axios({
        method: 'get',

        url: `project/comment/list/${this.task.project_id}/${this.task.id}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(res => {
        this.comments = res.data
      })
    },
    getFiles() {
      axios({
        method: 'get',

        url: `project/file/list/${this.task.project_id}/${this.task.id}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(res => {
        // Debug: console.log('Files data:', res.data)
        this.files = res.data
      })
    },
    deleteComment(id) {
      axios({
        method: 'delete',

        url: `project/comment/delete/${id}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(() => {
        this.getComments()
      })
    },
    getEmails() {
      axios({
        method: 'get',

        url: `project/email/list/${this.task.project_id}/${this.task.id}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(response => {
        this.emails = response.data
      })
    },
    deleteEmail(id) {
      axios({
        method: 'delete',

        url: `project/email/delete/${id}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }).then(() => {
        this.getEmails()
      })
    },
    saveEmail() {
      axios({
        method: 'post',

        url: 'project/email/create',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        data: {
          project_id: 0,
          project_task_id: this.task.id,
          title: this.email_title,
          incomming: this.email_incomming,
          link: this.email_link,
        },
      }).then(() => {
        // eslint-disable-next-line no-use-before-define
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Sikeresen létrehozva',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        this.email_title = null
        this.email_incomming = null
        this.email_link = null
        this.$bvModal.hide('createEmail')
        this.getEmails()
      }).catch(error => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: Object.values(error.response.data.errors)[0][0],
            icon: 'XOctagonIcon',
            variant: 'danger',
          },
        })
      })
    },
    // Image viewing methods
    async viewImage(fileId, fileName) {
      try {
        const response = await axios({
          method: 'post',
          url: 'project/file/download',
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
          responseType: 'blob',
          data: {
            id: fileId,
          },
        })

        const blob = new Blob([response.data])
        const imageUrl = URL.createObjectURL(blob)

        this.currentImageSrc = imageUrl
        this.currentImageName = fileName
        this.showImageViewer = true
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Hiba a kép betöltése során',
            icon: 'XOctagonIcon',
            variant: 'danger',
          },
        })
      }
    },
    closeImageViewer() {
      if (this.currentImageSrc && this.currentImageSrc.startsWith('blob:')) {
        URL.revokeObjectURL(this.currentImageSrc)
      }
      this.showImageViewer = false
      this.currentImageSrc = ''
      this.currentImageName = ''
      this.imageZoom = 1
    },
    imageZoomIn() {
      if (this.imageZoom < 3) {
        this.imageZoom += 0.2
      }
    },
    imageZoomOut() {
      if (this.imageZoom > 0.3) {
        this.imageZoom -= 0.2
      }
    },
    handleImageViewerKeydown(event) {
      if (this.showImageViewer) {
        switch (event.key) {
          case 'Escape':
            this.closeImageViewer()
            break
          case '+':
          case '=':
            event.preventDefault()
            this.imageZoomIn()
            break
          case '-':
            event.preventDefault()
            this.imageZoomOut()
            break
          default:
            // Do nothing for other keys
            break
        }
      }
    },
    handlePdfViewerKeydown(event) {
      if (this.showPdfViewer) {
        switch (event.key) {
          case 'Escape':
            this.closePdfViewer()
            break
          case '+':
          case '=':
            event.preventDefault()
            this.zoomIn()
            break
          case '-':
            event.preventDefault()
            this.zoomOut()
            break
          case 'ArrowLeft':
            event.preventDefault()
            this.previousPage()
            break
          case 'ArrowRight':
            event.preventDefault()
            this.nextPage()
            break
          default:
            // Do nothing for other keys
            break
        }
      }
    },
    // PDF viewing methods
    async viewPdf(fileId, fileName) {
      try {
        const response = await axios({
          method: 'post',
          url: 'project/file/download',
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
          responseType: 'blob',
          data: {
            id: fileId,
          },
        })

        const blob = new Blob([response.data], { type: 'application/pdf' })
        const pdfUrl = URL.createObjectURL(blob)
        this.currentPdfSrc = pdfUrl
        this.currentPdfName = fileName
        this.currentPage = 1
        this.totalPages = 1
        this.pdfScale = 1.2
        this.showPdfViewer = true
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Hiba a PDF betöltése során',
            icon: 'XOctagonIcon',
            variant: 'danger',
          },
        })
      }
    },
    closePdfViewer() {
      if (this.currentPdfSrc && this.currentPdfSrc.startsWith('blob:')) {
        URL.revokeObjectURL(this.currentPdfSrc)
      }
      this.showPdfViewer = false
      this.currentPdfSrc = ''
      this.currentPdfName = ''
      this.currentPage = 1
      this.totalPages = 1
      this.pdfScale = 1.2
    },
    // PDF navigation methods
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage -= 1
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage += 1
      }
    },
    zoomIn() {
      if (this.pdfScale < 3) {
        this.pdfScale += 0.2
        this.updatePdfScale()
      }
    },
    zoomOut() {
      if (this.pdfScale > 0.5) {
        this.pdfScale -= 0.2
        this.updatePdfScale()
      }
    },
    updatePdfScale() {
      // Force PDF re-render with new scale
      if (this.$refs.pdfComponent) {
        this.$refs.pdfComponent.$forceUpdate()
      }
    },
    onNumPagesLoaded(numPages) {
      this.totalPages = numPages
    },
    onPageLoaded() {
      // PDF oldal betöltve
    },
    onPdfError(error) {
      console.error('PDF loading error:', error)
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Hiba a PDF betöltése során',
          icon: 'XOctagonIcon',
          variant: 'danger',
        },
      })
    },
    // Cleanup method for image URLs
    cleanupImageUrls() {
      this.lightboxImages.forEach(image => {
        if (image.src && image.src.startsWith('blob:')) {
          URL.revokeObjectURL(image.src)
        }
      })
      this.lightboxImages = []
    },
  },
  setup(props, { emit }) {
    const {
      taskLocal,
      resetTaskLocal,
      // UI
      assigneeOptions,
      onSubmit,
      updateStatus,
      tagOptions,
      resolveAvatarVariant,
    } = useTaskHandler(toRefs(props), emit)

    const {
      refFormObserver,
      getValidationState,
      resetForm,
      clearForm,
    } = formValidation(resetTaskLocal, props.clearTaskData)

    const editorOption = {
      modules: {
        toolbar: '#quill-toolbar',
      },
      placeholder: 'Írj egy leírást...',
    }

    return {
      // Add New
      taskLocal,
      onSubmit,
      assigneeOptions,
      tagOptions,
      updateStatus,

      // Form Validation
      resetForm,
      clearForm,
      refFormObserver,
      getValidationState,

      // UI
      editorOption,
      resolveAvatarVariant,

      // Filter/Formatter
      avatarText,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/quill.scss';
</style>

<style lang="scss" scoped>
@import '~@core/scss/base/bootstrap-extended/include';

.assignee-selector {
  ::v-deep .vs__dropdown-toggle {
  padding-left: 0;
  }
}

#quil-content ::v-deep {
  > .ql-container {
    border-bottom: 0;
  }

  + #quill-toolbar {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-bottom-left-radius: $border-radius;
    border-bottom-right-radius: $border-radius;
  }
}
.mail-box{
  max-height:300px;
  overflow:auto;
}
.mail-box::-webkit-scrollbar {
  width: 5px;
}

/* Track */
.mail-box::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgb(179, 179, 179);
  border-radius: 10px;
}
/* Handle */
.mail-box::-webkit-scrollbar-thumb {
  background: #3e74c7;
  border-radius: 10px;
}

/* Handle on hover */
.mail-box::-webkit-scrollbar-thumb:hover {
  background: #3e74c7;
}

/* Modern PDF Viewer Styling */
::v-deep .modern-pdf-modal {
  .modal-dialog {
    max-width: 95vw !important;
    margin: 10px auto !important;
    height: calc(100vh - 20px) !important;
  }

  .modal-content {
    height: 100% !important;
    border-radius: 12px !important;
    overflow: hidden !important;
    background: transparent !important;
    border: none !important;
  }

  .modal-body {
    padding: 0 !important;
    height: 100% !important;
    overflow: hidden !important;
  }
}

.modern-pdf-viewer {
  height: 100% !important;
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%) !important;
  display: flex !important;
  flex-direction: column !important;
  position: relative !important;

  .pdf-header {
    background: rgba(0, 0, 0, 0.8) !important;
    backdrop-filter: blur(10px) !important;
    padding: 15px 20px !important;
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
    z-index: 1000 !important;

    .pdf-title {
      display: flex !important;
      align-items: center !important;
      font-weight: 500 !important;
      font-size: 16px !important;
    }

    .pdf-controls {
      display: flex !important;
      align-items: center !important;
      gap: 15px !important;

      .nav-controls,
      .zoom-controls {
        display: flex !important;
        align-items: center !important;
        gap: 5px !important;

        .page-indicator,
        .zoom-indicator {
          color: white !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          min-width: 80px !important;
          text-align: center !important;
          background: rgba(255, 255, 255, 0.1) !important;
          padding: 4px 12px !important;
          border-radius: 6px !important;
          margin: 0 5px !important;
        }
      }

      .btn-link {
        border: none !important;
        background: transparent !important;
        color: white !important;
        transition: all 0.2s ease !important;
        border-radius: 8px !important;

        &:hover {
          background: rgba(255, 255, 255, 0.1) !important;
          color: white !important;
          transform: scale(1.1) !important;
        }

        &:focus {
          box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.2) !important;
        }

        &:disabled {
          opacity: 0.4 !important;
          transform: none !important;
          background: transparent !important;
        }
      }
    }
  }

  .pdf-content-modern {
    flex: 1 !important;
    display: flex !important;
    align-items: flex-start !important;
    justify-content: center !important;
    padding: 20px !important;
    overflow: auto !important;
    background: #2c2c2c !important;

    .pdf-wrapper-modern {
      display: flex !important;
      align-items: flex-start !important;
      justify-content: center !important;
      min-height: 100% !important;
      width: 100% !important;

      canvas {
        border-radius: 8px !important;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.4) !important;
        transition: box-shadow 0.3s ease !important;
        background: white !important;
        min-height: 1000px !important;
        height: auto !important;
        width: auto !important;
        max-width: none !important;
        display: block !important;

        &:hover {
          box-shadow: 0 15px 50px rgba(0, 0, 0, 0.6) !important;
        }
      }

      // Override vue-pdf default styles
      ::v-deep .vue-pdf-component {
        width: 800px !important;
        min-height: 1000px !important;

        canvas {
          width: 800px !important;
          min-height: 1000px !important;
        }
      }
    }
  }

  .pdf-footer {
    background: rgba(0, 0, 0, 0.6) !important;
    padding: 10px 20px !important;
    text-align: center !important;
    border-top: 1px solid rgba(255, 255, 255, 0.1) !important;
  }
}

/* PDF content scrollbars */
.pdf-content-modern::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.pdf-content-modern::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

.pdf-content-modern::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 4px;
}

.pdf-content-modern::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}

/* Modern Image Viewer Styling */
::v-deep .modern-image-modal {
  .modal-dialog {
    max-width: 95vw !important;
    margin: 10px auto !important;
    height: calc(100vh - 20px) !important;
  }

  .modal-content {
    height: 100% !important;
    border-radius: 12px !important;
    overflow: hidden !important;
    background: transparent !important;
    border: none !important;
  }

  .modal-body {
    padding: 0 !important;
    height: 100% !important;
    overflow: hidden !important;
  }
}

.modern-image-viewer {
  height: 100% !important;
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%) !important;
  display: flex !important;
  flex-direction: column !important;
  position: relative !important;

  .image-header {
    background: rgba(0, 0, 0, 0.8) !important;
    backdrop-filter: blur(10px) !important;
    padding: 15px 20px !important;
    display: flex !important;
    justify-content: space-between !important;
    align-items: center !important;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
    z-index: 1000 !important;

    .image-title {
      display: flex !important;
      align-items: center !important;
      font-weight: 500 !important;
      font-size: 16px !important;
    }

    .image-controls {
      display: flex !important;
      align-items: center !important;
      gap: 5px !important;

      .zoom-indicator {
        color: white !important;
        font-size: 14px !important;
        font-weight: 500 !important;
        min-width: 50px !important;
        text-align: center !important;
        background: rgba(255, 255, 255, 0.1) !important;
        padding: 4px 8px !important;
        border-radius: 6px !important;
        margin: 0 5px !important;
      }

      .btn-link {
        border: none !important;
        background: transparent !important;
        color: white !important;
        transition: all 0.2s ease !important;
        border-radius: 8px !important;

        &:hover {
          background: rgba(255, 255, 255, 0.1) !important;
          color: white !important;
          transform: scale(1.1) !important;
        }

        &:focus {
          box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.2) !important;
        }
      }
    }
  }

  .image-content-modern {
    flex: 1 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    padding: 20px !important;
    overflow: auto !important;
    cursor: pointer !important;

    .image-wrapper {
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      max-width: 100% !important;
      max-height: 100% !important;

      .modern-image {
        max-width: 100% !important;
        max-height: 100% !important;
        object-fit: contain !important;
        border-radius: 8px !important;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.4) !important;
        transition: transform 0.3s ease !important;
        cursor: default !important;
        transform-origin: center center !important;

        &:hover {
          box-shadow: 0 15px 50px rgba(0, 0, 0, 0.6) !important;
        }
      }
    }
  }

  .image-footer {
    background: rgba(0, 0, 0, 0.6) !important;
    padding: 10px 20px !important;
    text-align: center !important;
    border-top: 1px solid rgba(255, 255, 255, 0.1) !important;
  }
}

/* Image content scrollbars */
.image-content-modern::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.image-content-modern::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

.image-content-modern::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 4px;
}

.image-content-modern::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}
</style>
